import React from 'react';
import { DISCLAIMER } from '../data/religia';
export function Footer() {
  return <footer className="w-full bg-slate-900 px-8 py-14 text-stone-50 sm:px-14" data-id="element-124" data-mp="3gf96f0gd6eb2">
      <div className="mx-auto max-w-6xl" data-id="element-125" data-mp="3gh3q6bfwg0dk">
        <p className="font-serif text-3xl tracking-tight" data-id="element-126" data-mp="32onk11rpbm8f">
          RELIGIA GOTOWA<span className="align-super text-[0.5em]" data-id="element-127" data-mp="36pfv80k4w17c">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-128" data-mp="36nd5lhmw8a35">
          RELIGIA GOTOWA™ to niezależne materiały pomocnicze dla katechetów i nauczycieli religii w szkole podstawowej. {DISCLAIMER}
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-129" data-mp="3lec9wggp4cgx">
          © 2026 RELIGIA GOTOWA™. Wszelkie prawa zastrzeżone.
        </p>
      </div>
    </footer>;
}